import { Divider, Stack, SxProps } from '@mui/material';
import { MainCategory } from './MainCategory';
import { Location } from './Location';
import { useIsDesktop } from 'Hooks';
import { SubCategories } from './SubCategories';
import { useContext } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import { SUPPLIERS_ID } from 'Enum/suppliers';

export interface ICriteriaStyle {
  autoCompleteSx: SxProps;
  autoCompletePaperSx: SxProps;
}

export const CriteriaFilter = () => {
  const { suppliersId } = useContext(SuppliersContext);

  const isDesktop = useIsDesktop();

  const autoCompleteSx: SxProps = {
    width: isDesktop ? undefined : 'fit-content',
    maxWidth: isDesktop ? undefined : '100%',
    margin: isDesktop ? undefined : 0,
    p: isDesktop ? '12px' : 0,

    '&&& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&&& .MuiInputBase-root input[dropdown="closed"] ~ fieldset': {
      border: 'none',
    },
    '&&& .MuiOutlinedInput-root': {
      minWidth: '75px',
      p: 0,
      display: 'flex',
      flexWrap: 'nowrap',
      cursor: 'pointer',
    },

    ':hover': {
      bgcolor: 'purple2.shade_100',
    },
  };

  const autoCompletePaperSx: SxProps = {
    minWidth: '100px',
    maxWidth: '303px',
    m: '16px 0 0 -10px',
    border: '1px solid #A020FF',
    borderTop: 'none',
    overflow: 'hidden !important',
  };

  return (
    <Stack
      direction='row'
      alignItems='center'
      flexWrap={isDesktop ? undefined : 'wrap'}
      rowGap={isDesktop ? undefined : '8px'}
      sx={{
        width: 'fit-content',
      }}
    >
      <MainCategory
        autoCompleteSx={autoCompleteSx}
        autoCompletePaperSx={autoCompletePaperSx}
      />
      {isDesktop && (
        <Divider
          orientation='horizontal'
          sx={{
            m: 'auto 12px',
            bgcolor: 'purple2.shade_300',
            width: '1px',
            height: '47px',
          }}
          aria-hidden={true}
        />
      )}
      <Stack
        direction='row'
        alignItems='center'
        sx={{
          width: 'fit-content',
        }}
      >
        {suppliersId === SUPPLIERS_ID.mentalTherapy && (
          <>
            <SubCategories
              autoCompleteSx={autoCompleteSx}
              autoCompletePaperSx={autoCompletePaperSx}
            />
            <Divider
              orientation='horizontal'
              sx={{
                m: '0 12px',
                bgcolor: 'purple2.shade_300',
                width: '1px',
                height: isDesktop ? '47px' : '16px',
              }}
              aria-hidden={true}
            />
          </>
        )}
        <Location
          autoCompleteSx={autoCompleteSx}
          autoCompletePaperSx={autoCompletePaperSx}
        />
      </Stack>
    </Stack>
  );
};
